export default __webpack_public_path__ + "static/media/image_31-902.e749dd89.png";